import React from 'react'

import { useTenant } from '@rewardops/auth/src/client/use-tenant'

import { BirchLogo } from '~/components/birch/birch-logo'
import MapleLogo from './maple/maple-logo'

interface LogoProps {
  className?: string
}

const Logo = ({ className }: LogoProps) => {
  const tenant = useTenant()
  switch (tenant.theme) {
    case 'birch':
      return <BirchLogo className={className} />
    case 'maple':
    case 'pointsAtWork':
      return <MapleLogo className={className} />
    default:
      return <>Error 100</>
  }
}

export { Logo }
